import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/mcomponent/octopart_account/');

const state = {
    ...current_module.state,
    columns: [
        {text: '', value: 'deleted', sortable: false, filterable: true, divider: true, width: 30},
        {text: '', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'URL', value: 'url', sortable: false, filterable: true, divider: true},
        {text: 'Email', value: 'email', sortable: false, filterable: true, divider: true},
        {text: 'Email password', value: 'email_password', sortable: false, filterable: true, divider: true},
        {text: 'Octopart account', value: 'octopart_account', sortable: false, filterable: true, divider: true},
        {text: 'Octopart password', value: 'octopart_pssword', sortable: false, filterable: true, divider: true},
        {text: 'Client ID', value: 'nexar_client_id', sortable: false, filterable: true, divider: true},
        {text: 'Client secret', value: 'nexar_client_secret', sortable: false, filterable: true, divider: true},
        {text: 'Created by', value: 'created_by_name', sortable: true, divider: true, },
        {text: 'Created on', value: 'created_on', sortable: true, divider: true, type: 'datetime',},
        {text: 'Edited by', value: 'edited_by_name', sortable: true, divider: true, },
        {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, type: 'datetime', },
    ],
    options: {
        page: 1,
        itemsPerPage: 50,
        sortBy: ['id'],
        sortDesc: [true],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
    filtersArg: {
        from_date: null,
        to_date: null,
    },
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        OctopartAccountTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}